import { Divider, Grid, Chip, Avatar, Typography, Link } from '@material-ui/core';
import { SectionTitle, SubSectionTitle } from '../common';
import { blue, lime } from '@material-ui/core/colors';
import ContactMailRoundedIcon from '@material-ui/icons/ContactMailRounded';
import PersonPinCircleRoundedIcon from '@material-ui/icons/PersonPinCircleRounded';
import { CompanyBasicFormField, HQLocationField, OtherOfficesField } from '../fields';
import { useFormContext } from 'react-hook-form';
import { HelperTextTip } from '@components/hepler-text-tip';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';

interface SectionIsClientContentServicesProps {
  services: {
    vtr_company_name: string;
    company_service_id: number;
    count: number;
  }[];
  vtr_company_name: string;
}
export const SectionIsClientContentServices = ({
  services,
  vtr_company_name,
}: SectionIsClientContentServicesProps) => {
  const classesNew = useStyles();
  return (
    <>
      <SectionTitle
        title="Company is Client of:"
        id="content-services-info"
        subTitle="List of companies and relations count"
        icon={<AccountBalanceWalletIcon color="primary" fontSize="large" />}
      />

      <Divider />
      <br />
      <div>
        {services.length > 0 ? (
          services.map((service_content, index) => (
            <Link
              href={`${window.location.origin}/company-content/search?filters[0].id=client_name&filters[0].value.$eq=${vtr_company_name}&filters[1].id=company_name&filters[1].value.$eq=${service_content.vtr_company_name}`}
              target="_blank">
              <Chip
                color="primary"
                label={service_content.vtr_company_name}
                key={index}
                avatar={<Avatar>{service_content.count}</Avatar>}
                style={{ marginRight: '10px', marginBottom: '10px' }}
                className={classesNew.chip}
                clickable
                // onClick={() => {
                //   console.log('HI');
                // }}
              />
            </Link>
          ))
        ) : (
          <Typography variant="body2" style={{ fontStyle: 'italic' }}>
            Empty
          </Typography>
        )}
      </div>
    </>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      //   display: 'flex',
      //   alignItems: 'right',
      //   justifyContent: 'right',
    },
  })
);
